import { axiosFactory, axiosPostFactory, axiosFormFactory } from './axios-factory'

export default {
    getRemarksList(params) {
        return axiosFactory({
            method: 'get',
            url: `/search/index.php?m=Search&c=ResourceXch&a=getXchComment&rid=${params.rid}&page=${params.page}`,
        })
    },
    addRemark(data) {
        return axiosPostFactory({
            url: `/search/index.php?m=Search&c=ResourceXch&a=xchComment`,
            data
        })
    },
    getDetailInfo(resId) {
        return axiosFactory({
            method: 'get',
            url: `/search/index.php?m=search&c=ResourceXch&a=xchPreview&resId=${resId}`,
        })
    },
    getPackageList(params) {
        return axiosFactory({
            method: 'get',
            url: `/search/index.php?m=Search&c=ResourceXch&a=getXchPackageList&resId=${params.rid}&page=${params.page}`,
        })
    },
    addScore(data) {
        return axiosPostFactory({
            url: `/search/index.php?m=Search&c=ResourceXch&a=xchAddScore`,
            data
        })
    },
    resDownload(data) {
        return axiosPostFactory({
            url: `/search/index.php?m=Search&c=ResourceXch&a=xchDownload`,
            data
        })
    },
}
